import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useStore } from "../lib/store";

export function ScrollToTop() {
  const { pathname } = useLocation();
  const first = React.useRef(true);
  useEffect(() => {
    window.scrollTo(0, 0);
    // Base pixel code in index.html already fires PageView on first load; fire for SPA navigations here.
    if (first.current) { first.current = false; return; }
    if (window.fbq) window.fbq("track", "PageView");
  }, [pathname]);
  return null;
}

export function ConsentBanner() {
  const { consent, setConsent } = useStore();
  if (consent !== null) return null;
  const choose = (v) => { setConsent(v); localStorage.setItem("hh_consent", JSON.stringify(v)); };
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.4 }}
      className="fixed bottom-0 sm:bottom-4 left-0 right-0 sm:left-4 sm:right-auto sm:max-w-sm z-[55] bg-white border-t sm:border border-line sm:rounded-2xl px-4 py-3 sm:p-4 text-sm shadow-[0_-8px_30px_-18px_rgba(7,40,53,0.3)] safe-bottom"
      role="region" aria-label="Cookie consent" data-testid="consent-banner">
      <div className="flex sm:block items-center gap-3">
        <div className="flex-1 min-w-0">
          <p>May we use cookies for analytics?</p>
          <p className="text-subtext mt-0.5 text-xs hidden sm:block">We'd like to measure how the shop is used — never personal or address details. You can change your mind anytime.</p>
        </div>
        <div className="flex gap-2 sm:mt-3 shrink-0">
          <button data-testid="consent-accept" onClick={() => choose("all")} className="bg-forest text-white px-4 h-10 rounded-full text-xs">Accept</button>
          <button data-testid="consent-reject" onClick={() => choose("necessary")} className="border border-line px-3 h-10 rounded-full text-xs">Necessary</button>
        </div>
      </div>
    </motion.div>
  );
}

export function BackToTop() {
  const [show, setShow] = React.useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Back to top" data-testid="back-to-top"
      className={`fixed bottom-24 lg:bottom-6 right-4 lg:right-6 z-40 w-11 h-11 rounded-full bg-white border border-line shadow-md flex items-center justify-center transition-all duration-300 hover:bg-forest hover:text-white ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m18 15-6-6-6 6" /></svg>
    </button>
  );
}
